import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import cookie from "../func/Cookie";
import {HandleSubmit} from '../func/HandleSubmit'
let passRef;
let userRef;
let btnRef;

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: this.props.open,
            LoginStatus: (cookie.get("token") === "") ? false : true,
            SendParameters: {
                user: cookie.get("user"),
                name: cookie.get("name"),
                token: cookie.get("token"),
            }
        }
        this.Login = this.Login.bind(this);
        this.SetParameterValue = this.SetParameterValue.bind(this);
        this.Logout = this.Logout.bind(this);
        this.SetLogin = this.props.SetLogin.bind(this);
    }
    checkValue() {
        //this.state.SendParameters
    }
    SetParameterValue(name, value) {
        this.state.SendParameters = { ...this.state.SendParameters, [name]: value };
        this.setState({
            SendParameters: this.state.SendParameters,
        });
        console.log(this.state.SendParameters);
    }
    handleKeyPress = (event) => {
        if (event.key == 'Enter') {
            switch (event.target.name) {
                case 'user':
                    {
                        //console.log(event.target.name);
                        passRef.focus();
                        break;
                    }
                case 'pass':
                    {
                        //console.log(event.target.name);
                        //btnRef.focus();
                        this.Login();
                        break;
                    }

            }

        }
    }
    async Login() {
        //console.log("cook1: ", "startr");
        let response = await HandleSubmit('user/login', this.state.SendParameters);
        //console.log("access: ");
        if ((response).status === "OK") {
            cookie.set("name", (response).name);
            cookie.set("user", (response).user);
            cookie.set("token", (response).token);
            cookie.set("access", (response).access);
            this.setState({
                SendParameters: this.state.SendParameters,
                LoginStatus: true,
            });
            this.SetLogin();
            //alert(document.cookie);
        }
    }
    Logout() {
        this.state.SendParameters.user = "";
        this.state.SendParameters.token = "";
        this.state.SendParameters.name = "";
        this.setState({
            LoginStatus: false,
            SendParameters: this.state.SendParameters,
        });
        cookie.set("user", "");
        cookie.set("name", "");
        cookie.set("token", "");
        cookie.set("access", "");
        this.SetLogin();
    }
    async componentDidMount() {
        //await this.Login();
    }
    render() {

        return (<Collapse isOpened={this.props.open}>
            {this.state.LoginStatus ?
                <div className="container">
                    <div className="row">
                        <div className="col-4">
                            <ul className="list-inline">
                                <li className="list-inline-item"> نام کاربری </li>
                                <li className="list-inline-item">{cookie.get("name")}</li>
                            </ul>
                            <ul className="list-inline">
                                <li className="list-inline-item"><button onClick={this.Logout}>خروج</button> </li>
                            </ul>
                        </div>
                        <div className="col-4">
                        </div>
                        <div className="col-4">
                        </div>
                    </div>
                </div>
                : <div className="container">
                    <div className="row">
                        <div className="col-4">
                            <ul className="list-inline">
                                <li className="list-inline-item"> نام کاربری </li>
                                <li className="list-inline-item"><input className="form-control" type="text" placeholder="نام کاربری"
                                    name="user"
                                    ref={(ref) => userRef = ref}
                                    onChange={(e) => this.SetParameterValue("user", e.target.value)}
                                    onKeyPress={(e) => this.handleKeyPress(e)}
                                /></li>
                            </ul>
                            <ul className="list-inline">
                                <li className="list-inline-item">رمز عبور </li>
                                <li className="list-inline-item"><input className="form-control" type="password" placeholder=" رمز عبور"
                                    name="pass"
                                    ref={(ref) => passRef = ref}
                                    onChange={(e) => this.SetParameterValue("pass", e.target.value)}
                                    onKeyPress={(e) => this.handleKeyPress(e)}
                                /></li>
                            </ul>
                            <ul className="list-inline">
                                <li className="list-inline-item"><button ref={(ref) => btnRef = ref} onClick={this.Login}>ورود</button> </li>
                            </ul>
                        </div>
                        <div className="col-4">
                        </div>
                        <div className="col-4">
                        </div>
                    </div>
                </div>
            }
        </Collapse>
        )
    }
}
export default Login;


// WEBPACK FOOTER //
// ./src/layout/Login.js